export const SEQUENCE_LOCKING_HELP_TEXT =
  'The bases, annotations, primers, and translations of a locked sequence cannot be edited. Linked analyses and metadata can still be updated.';

export const FOLDER_LOCKING_HELP_TEXT =
  'Locking a project will lock all of its current sequences and new ones you add. You can still unlock individual sequences in a locked project.';
